import type { ReactNode } from 'react';

import type { SelectConditionSection } from '@jane/shared-b2b/components';

/** The rules key the products condition saves under */
export const PRODUCTS_KEY = 'product_ids';

/** Just the fields a condition tag renders. `id` is the id the special saves */
export interface ProductConditionItem {
  id: string;
  name: string;
}

/** The "Apply to" mode the section is being built for */
export type ProductsSectionMode = 'attributes' | 'products';

/**
 * Under "Category, brand, and more", products can only narrow the other
 * conditions, so that mode excludes only. "Individual products" offers both.
 */
const modeFields = (
  mode: ProductsSectionMode
): Pick<SelectConditionSection, 'allowExcludes' | 'label' | 'selectionType'> =>
  mode === 'attributes'
    ? { label: 'Exclude Products', selectionType: 'excludes' }
    : { allowExcludes: true, label: 'Products' };

/**
 * The products condition as one section. `items` holds only the selected
 * products; the paginated catalog lives in the picker `renderModal` opens.
 */
export const toProductsSection = (
  products: ProductConditionItem[],
  renderModal: () => ReactNode,
  mode: ProductsSectionMode
): SelectConditionSection => ({
  ...modeFields(mode),
  items: products.map((product) => ({
    label: product.name,
    value: product.id,
  })),
  key: PRODUCTS_KEY,
  modalVariant: 'flex',
  renderModal,
  type: 'multiselect',
});
